export default "__VITE_ASSET__369d27cc__"